<template>
  <div id="page-user-edit">

    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="user_data">

      <div slot="no-body" class="tabs-container px-6 pt-6">

        <vs-tabs v-model="activeTab" class="tab-action-btn-fill-conatiner">
          <vs-tab label="Details" icon-pack="feather" icon="icon-edit">
            <div class="tab-text">
              <blogsEditDetails class="mt-4" :data="user_data" />
            </div>
          </vs-tab>
        </vs-tabs>

      </div>

    </vx-card>
  </div>
</template>

<script>
import blogsEditDetails from './blogsEditDetails.vue'

// Store Module
import moduleBlogs from '@/store/blogs/moduleBlogs.js'

export default {
  components: {
    blogsEditDetails
  },
  data () {
    return {
      user_data: null,
      user_not_found: false,

      /*
        This property is created for fetching latest data from API when tab is changed

        Please check it's watcher
      */
      activeTab: 0
    }
  },
  watch: {
    activeTab () {
      this.fetch_user_data(this.$route.params.blogId)
    }
  },
  methods: {
    fetch_user_data (blogId) {
      // console.log('blog id in fetch user data', blogId)
      this.$store.dispatch('blogs/fetchBlog', blogId)
        .then(res => {
          this.user_data = res.data.data
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.user_not_found = true
            return
          }
          console.error(err) 
        })
    }
  },
  created () {
    // Register Module blogs Module
    if (!moduleBlogs.isRegistered) {
      this.$store.registerModule('blogs', moduleBlogs)
      moduleBlogs.isRegistered = true
    }
    this.fetch_user_data(this.$route.params.userId)
  }
}

</script>
